module.exports = __webpack_public_path__ + "778c1676e65b3d31ca5418c56549ba19.svg";